import { LoadFreespinCommand } from "slotworks/commands/comms/load-freespin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SettingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import State from "slotworks/state-machine/states/state";
import Parallel from "slotworks/utils/contracts/parallel";

export default class RequestFreespin extends State {
    private skipping: boolean;

    public onEnter(cascadeSkip?: boolean) {

        this.skipping = cascadeSkip;

        Components.footer.showFreespinStart();

        new Parallel([
            () => StartSpinCommand(),
            () => LoadFreespinCommand()
        ]).then(() => {
            if (!GameState.getCurrentGame().getCurrentRecord()) {
                this.error();
            } else {
                GameState.getCurrentGame().nextRecord();

                if (this.skipping) {
                    this.skip();
                } else {
                    this.complete();

                }
            }
        });
    }

    public error() {
        Components.matrix.reset();
        Services.autoplay.stop();
        SettingsModel.setTurboSpin(false);
        SmartUIManager.refresh();

        super.error();
    }

    public onSkip() {
        this.skipping = true;
    }
}
